/**
 * Removes the part after "upload" from a Cloudinary image URL.
 * Returns undefined if "upload" is not found in the URL.
 * Ensures the final URL starts with "https:".
 *
 * @param {string} url - The Cloudinary image URL.
 * @returns {string | undefined} - The processed URL or undefined if invalid.
 */
export function removeCloudinaryTransform(url: string): string | undefined {
  const parts = url.split('/');

  const uploadIndex = parts.indexOf('upload');
  if (uploadIndex === -1) return undefined;

  // Remove the part immediately after "upload"
  parts.splice(uploadIndex + 1, 1);

  // Rebuild the URL
  let cleanedUrl = parts.join('/');

  // Ensure the result starts with "https:"
  if (!cleanedUrl.startsWith('https:')) {
    cleanedUrl = 'https:' + cleanedUrl;
  }

  return cleanedUrl;
}
